import { useContext } from 'react'

import {
  AuthContext,
  type AuthContextValue,
  AuthProvider,
} from '@/contexts/auth-context'

export { AuthProvider }
export type { AuthContextValue }

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }

  return context
}
